// Full-document render of the lookup-orders-by-email ("Check Your Order
// Status") page: PageSkeleton wrapping sealy's LookupOrdersByEmailBody.
import React from "react";

import { templates } from "@reactivated";

import { LookupOrdersByEmailBody } from "../components/LookupOrdersByEmailBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <LookupOrdersByEmailBody {...props} />
        </PageSkeleton>
    );
};
